import { MutationCache, QueryCache, QueryClient } from "@tanstack/react-query";
import { createIDBPersister, showErrorToast } from "./utils";
import { ErrorResponse } from "./types";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      networkMode: "offlineFirst",
      staleTime: 0,
      refetchOnMount: true,
      retry: (failureCount) => {
        if (!navigator.onLine) return false;
        return failureCount < 3;
      },
    },
    mutations: {
      networkMode: "offlineFirst",
      retry: (failureCount) => {
        if (!navigator.onLine) return false;
        return failureCount < 1;
      },
    },
  },
  queryCache: new QueryCache({
    onError: () => {
      // showErrorToast(error);
    },
  }),
  mutationCache: new MutationCache({
    onError: (error: ErrorResponse | Error) => {
      if (
        (error as ErrorResponse).response?.data.message ===
        "Invalid username or password"
      ) {
        return;
      }
      showErrorToast(error as ErrorResponse);
    },
  }),
});

export const persister = createIDBPersister();

/** Drop every cached query and mutation, in memory and in IndexedDB. */
export async function clearPersistedCache(): Promise<void> {
  queryClient.clear();
  await persister.removeClient();
}
